module.exports = "/8/3-con-tr-va-mang-ki-tu/index.html.dc406539fbe2db6bafb4f3a63ad20fbc.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/30876.md
 ** module id = 569
 ** module chunks = 0
 **/